import {
  KM,
  PLATE,
  RENAVAM,
  CHASSIS,
  COLOR,
  LICENSING_UF,
  LICENSING_CITY,
} from './fields';

export default function payload() {
  return {
    km_mileage: {
      field: KM,
      // getter: () => '',
      reveal: true,
    },
    license_plate_code: {
      field: PLATE,
      // getter: () => '',
      reveal: true,
    },
    renavam_code: {
      field: RENAVAM,
      // getter: () => '',
      reveal: true,
    },
    chassi_code: {
      field: CHASSIS,
      // getter: () => '',
      reveal: true,
    },
    color: {
      field: COLOR,
      // getter: () => '',
      reveal: true,
    },
    licensing_uf: {
      field: LICENSING_UF,
      // getter: () => '',
      reveal: false,
    },
    licensing_city: {
      field: LICENSING_CITY,
      // getter: () => '',
      reveal: true,
    },
  };
}
